<template>
  <ul class="px-[10px]">
    <NFTCard
      v-for="value in nfts.items"
      :key="value.id"
      :nft="value" />
  </ul>
</template>

<script>
import NFTCard from '@/components/common/NFTCard.vue';

export default {
  name: 'AllNFTsList',
  components: {
    NFTCard,
  },
  props: {
    nfts: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
